export const Payment = {
  _request_payment_confirmation: function(){
    // Format currencies on load
    jQuery("input[data-currency-format]").each(function () {
      var unformatted = jQuery(this).val();
      if (unformatted.length > 0) {
        jQuery(this).data("unformatted-val", unformatted);
        jQuery(this).val(SmartME.formatCurrency(unformatted, jQuery(this).data("currency-format")));
      }
    });

    // Unformat on focus
    jQuery("input[data-currency-format]").on("focus", function () {
      jQuery(this).val(jQuery(this).data("unformatted-val"));
    });

    // Format on blur
    jQuery("input[data-currency-format]").on("blur", function () {
      var unformatted = jQuery(this).val();

      if (unformatted.length > 0) {
        jQuery(this).data("unformatted-val", unformatted);
        jQuery(this).val(SmartME.formatCurrency(unformatted, jQuery(this).data("currency-format")));
      }
    });

    // Unformat all on submit
    jQuery("input[data-currency-format]").closest('form').each(function () {
      jQuery(this).on("submit", function () {
        jQuery(this).find("input[data-currency-format]").each(function () {
          if (jQuery(this).val().length > 0) {
            jQuery(this).val(jQuery(this).data("unformatted-val"));
          }
        });
      })
    });

    jQuery(".datetimepicker").flatpickr({ dateFormat: "Y-m-d", allowInput: true });
  },

  _confirm_payment: function () {
    jQuery(".confirm-payment-form").on("submit", function(e) {
      e.preventDefault();

      var form = jQuery(this);

      jQuery.post(form.data("action"), form.serialize(), function () {
        Turbo.visit(window.location.href);
      });

      return false;
    });
  },

  _payment_not_available_for_confirmation: function() {
    jQuery(".modal-footer").hide();
  },

  new_payment: function() {
        // Format currencies on load
        jQuery('input[data-currency-format]').each(function(){
          var unformatted = jQuery(this).val();
          if (unformatted.length > 0) {
            jQuery(this).data('unformatted-val', unformatted);
            jQuery(this).val(SmartME.formatCurrency(unformatted, jQuery(this).data('currency-format')))
          }
        });
    
        // Unformat on focus
        jQuery('input[data-currency-format]').on('focus', function(){
          jQuery(this).val(jQuery(this).data('unformatted-val'));
        });
    
        // Format on blur
        jQuery('input[data-currency-format]').on('blur', function(){
          var unformatted = jQuery(this).val();
    
          if (unformatted.length > 0) {
            jQuery(this).data('unformatted-val', unformatted);
            jQuery(this).val(SmartME.formatCurrency(unformatted, jQuery(this).data('currency-format')))
          }
        });

        // New payment submit
        jQuery('#payment-save').on('click', function(e){
          var payment_form = jQuery('#new-payment-form')
          var payment_details_form = jQuery('#payment-details-form')

          // Unformat on submit. Store the unformatted value.
          jQuery('input[data-currency-format]').each(function(){
            if (jQuery(this).val().length > 0) {
              jQuery(this).val(jQuery(this).data('unformatted-val'));
            }
          });
          e.preventDefault();
          jQuery.ajax({
            url: payment_form.data('action'),
            data: payment_form.serialize(),
            type: 'POST',
            success: function(p){
              if(payment_details_form.data('action')){
                if (p.status == 'success') {
                  jQuery.ajax({
                    url: payment_details_form.data('action').replace('__payment_id__', p.payment.id),
                    data: payment_details_form.serialize(),
                    type: 'POST',
                    success: function(e){
                      jQuery('#modal-dialog', top.document).modal('hide');
                      Turbo.visit(location.href, {action: 'replace'});
                    }
                  })
                } else {
                  // Hacky way, show alert only so additional forms answers presist
                  var resDom = $( '<div></div>' );
                  resDom.html(p);
                  var warning = $('ul', resDom)
                  warning.attr('payment-jquery-target', 'target')
                  jQuery('[payment-jquery-target=target]').first().remove()
                  jQuery('[name=authenticity_token]').first().after(warning)
                }
              }else{
                // If errors in form, display new form with the errors
                if (p.status == 'success') {
                  jQuery('#modal-dialog', top.document).modal('hide');
                  Turbo.visit(location.href, {action: 'replace'});
                } else {
                  jQuery('.modal-body').html(p)
                }
              }
            }
          })
          return false
        })

        // Edit payment submit
        jQuery('#payment-update').on('click', function(e){
          var payment_form = jQuery('#edit-payment-form')
          var payment_details_form = jQuery('#payment-details-form')
          // Unformat on submit. Store the unformatted value.
          jQuery('input[data-currency-format]').each(function(){
            if (jQuery(this).val().length > 0) {
              jQuery(this).val(jQuery(this).data('unformatted-val'));
            }
          });
          e.preventDefault();
          jQuery.ajax({
            url: payment_form.data('action'),
            data: payment_form.serialize(),
            type: 'POST',
            success: function(p){
              if(payment_details_form.data('action')){
                if (p.status == 'success') {
                  jQuery.ajax({
                    url: payment_details_form.data('action'),
                    data: payment_details_form.serialize(),
                    type: 'POST',
                    success: function(e){
                      jQuery('#modal-dialog', top.document).modal('hide');
                      Turbo.visit(location.href, {action: 'replace'});
                    }
                  })
                } else {
                  // Hacky way, show alert only so additional forms answers presist
                  var resDom = $('<div></div>');
                  resDom.html(p);
                  var warning = $('ul', resDom)
                  warning.attr('payment-jquery-target', 'target')
                  jQuery('[payment-jquery-target=target]').first().remove()
                  jQuery('[name=authenticity_token]').first().after(warning)
                }
              }else{
                // If errors in form, display new form with the errors
                if (p.status == 'success') {
                  jQuery('#modal-dialog', top.document).modal('hide');
                  Turbo.visit(location.href, {action: 'replace'});
                } else {
                  jQuery('.modal-body').html(p)
                }
              }
            }
          })
          return false
        })

        jQuery('#payment-cancel').on('click', function(e){
          jQuery('#modal-dialog', top.document).modal('hide');
        })
  },

  edit_payment: function() {
    ActionJS.Payment.new_payment();
  },

  paymentsUpdateVisibleColumns: function (e, i) {
    // Deprecated ?
    var elem = jQuery(e.target);

    if (elem.is('input')) {
      var dropdown = elem.closest('.variable-columns');
      var index = parseInt(elem.attr('data-index'), 10);
      var visible = elem.prop('checked');
      var ids = [];
      var cols = [];
      dropdown.find('input').each(function () {
        if (this.checked && !isNaN(parseInt(this.value))) {
          ids.push(this.value);
        } else if (!this.checked && isNaN(parseInt(this.value))) {
          cols.push(this.value);
        }
      });

      ActionJS.Monitoring.priv.paymentsTables[i].column(index).visible(visible);
      ActionJS.Monitoring.priv.paymentsTables[i].draw();
      jQuery.post(dropdown.attr('data-url'), { report_variable_ids: ids, columns: cols });
    }

    e.stopPropagation();
  },

}
